<template>
  <div> 
    <!-- Attach this `refreshKey` to the component(s) you want to refresh -->
    <slot v-bind="{refreshKey}" />
  </div>
</template>

<script>
function* keyGenerator (prefix) {
  for (let i = 1; ; i++) yield `${prefix}-${i}`
}
export default {
  name: 'KeyRefresher',
  props: {
    /** Pass in a unique key that will be used to refresh wrapped components */
    uniqueKey: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      /** 
       * Generator function to infinitely create new keys 
       * @see function* keyGenerator(prefix) above
       */
      keyGenerator: keyGenerator(this.uniqueKey),
      /** Most-recent generation result */
      generatedKey: undefined,
    }
  },
  computed: {
    /**
     * Assign this key to nested components that should refresh when `refresh` is called
     * @see refresh
     */
    refreshKey: {
      get () {
        if (!this.generatedKey) return this.uniqueKey
        return this.generatedKey
      },
      set (value) {
        this.generatedKey = value
      }
    },
  },
  methods: {
    /** 
     * Generated a new key that can be used to refresh nested components, and assigns
     * the new value to `refreshKey`.
     * 
     * Call `refresh` using refs to trigger a refresh of nested components assigned `refreshKey` 
     * @param {Number} timeout Optional time to wait before performing refresh
     * @see refreshKey
     */
    refresh (timeout = 0) {
      setTimeout(() => this.refreshKey = this.keyGenerator.next().value, timeout)
    }
  }
}
</script>